<template>
    <div class="index">
      <div class="whatPay">
        <div class="title">什么是<span style="color: #F40009">金融支付</span></div>
        <div class="des">FINANCIAL PAYMENT</div>
        <div class="content">
          <img src="@/assets/img/solition/whatPay.png" alt="">
          <div>
            第三方支付整体解决方案 <br>
            该方案可支持多款业务产品<br>
            多种通道的接入以及模块化服务<br>
            带给客户更多的服务选择权<br>
            集成多种支付方式<br>
            让支付流程更简洁<br>
            客户操作更简单<br>
            支付更高效<br>
            <img class="line" src="@/assets/img/aboutUs/line.png" alt="">

          </div>
        </div>
      </div>
      <div class="platform">
        <div class="title">金融支付<span style="color: #F40009">平台</span></div>
        <div class="des">PAYMENT PLATFORM</div>
        <div class="content">
          <div>
            <img src="@/assets/img/solition/yhzf.png" alt="">
            银行支付
          </div>
          <div>
            <img src="@/assets/img/solition/sjzf.png" alt="">
            手机支付
          </div>
          <div>
            <img src="@/assets/img/solition/smzf.png" alt="">
            扫码支付
          </div>
          <div>
            <img src="@/assets/img/solition/wyzf.png" alt="">
            网页支付
          </div>
          <div>
            <img src="@/assets/img/solition/pzf.png" alt="">
            pos支付
          </div>
          <div>
            <img src="@/assets/img/solition/sfsm.png" alt="">
            商家扫码
          </div>
        </div>
      </div>
      <div class="helpyou">
        <div class="title">如何帮到<span style="color:#F40009;">您</span></div>
        <div class="des">HELP YOU</div>
        <div class="content">
          <div class="box">
            <div class="img" style="overflow: hidden;">
              <img  src="@/assets/img/solition/7.png" alt="">
            </div>
            <div class="title1">线下综合收单</div>
            <div class="des1">
              让刷卡+扫码一机解决 <br>
              轻松搞定会员、卡券、营销管理<br>
              让支付变得更加便捷
            </div>
          </div>
          <div class="box">
            <div class="img" style="overflow: hidden;">
              <img  src="@/assets/img/solition/8.png" alt="">
            </div>
            <div class="title1">线上支付系统</div>
            <div class="des1">
              支付系统涵盖了B2B、B2C以及快捷 <br>
              支付方式,安全、高效、稳定
            </div>
          </div>
          <div class="box">
            <div class="img" style="overflow: hidden;">
              <img  src="@/assets/img/solition/9.png" alt="">
            </div>
            <div class="title1">综合支付</div>
            <div class="des1">
              打通线上、线下一体化支付,统 <br>
              了会员、账户、账务的运作, <br>
              让清、结算变得简单、高效
            </div>
          </div>
          <div class="box">
            <div class="img" style="overflow: hidden;">
              <img  src="@/assets/img/solition/10.png" alt="">
            </div>
            <div class="title1">征信系统</div>
            <div class="des1">
              实现社会受众、征信机构、支付 <br>
              机构、信贷机构、金融机构之间 <br>
              的数据信息流转
            </div>
          </div>
        </div>
      </div>
      <div class="BRILLIANT">
        <div class="title">我们<span style="color: #F40009">在行</span>的</div>
        <div class="des">BRILLIANT</div>
      </div>
      <div class="row " :class="index==0?'marginTop':''" v-for="(item,index) in list" :key="index">
        <div class="title">
          <img src="@/assets/img/solition/left.png" alt="">
          <span>{{item.title}}</span>
          <img src="@/assets/img/solition/right.png" alt="">
        </div>
        <img class="img" :src="item.img" alt="">
      </div>
    </div>
</template>

<script>
    /**
     *
     * @Author zzl
     * @Date 2020/11/20 14:28.
     */
    import img1 from '@/assets/img/solition/yhyx.jpg'
    import img2 from '@/assets/img/solition/znpsmzf.jpg'
    import img3 from '@/assets/img/solition/jypsmzf.jpg'
    import img4 from '@/assets/img/solition/tmsmqzf.jpg'
    import img5 from '@/assets/img/solition/pcsyrj.jpg'
    import img6 from '@/assets/img/solition/gdjhmsmzf.jpg'
    export default {
        mounted() {
          window.scrollTo(0,0);
        },
        components: {},
        props: {},
        data() {
            return {
              list:[
                {img:img1,title:'银行营销（农商行）'},{img:img2,title:'智能pos扫码支付'},{img:img3,title:'简易pos扫码支付'},
                {img:img4,title:'条码扫描枪支付'},{img:img5,title:'PC收银软件'},{img:img6,title:'固定聚合码扫码支付'},
                ]
            }
        },
        computed: {},
        methods: {},
        watch: {},
        filters: {},
        beforeDestroy() {

        }
    }
</script>

<style lang="less" scoped>
.index{
  width: 100%;
  min-width: 1920px;
  .whatPay{
    width: 100%;
    height: 870px;
    position: relative;
    .title{
      position: absolute;
      top: 190px;
      left: 0;
      text-align: center;
      width: 100%;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: #232330;
      z-index: 9;
    }
    .des{
      position: absolute;
      top: 120px;
      left: 0;
      text-align: center;
      width: 100%;
      font-size: 100px;
      font-family: Source Han Sans CN;
      font-weight: 800;
      color: #F6F6F6;
    }
    .content{
      width: 100%;
      position: absolute;
      top: 370px;
      left: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      font-size: 24px;
      line-height: 50px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: #333333;
      img{
        margin-right: 103px;
      }
      .line{
        width: 154px;
      }
    }
  }
  .platform{
    width: 100%;
    height: 450px;
    position: relative;
    .title{
      position: absolute;
      top: 68px;
      left: 0;
      text-align: center;
      width: 100%;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: #232330;
      z-index: 9;
    }
    .des{
      position: absolute;
      top: 0px;
      left: 0;
      text-align: center;
      width: 100%;
      font-size: 100px;
      font-family: Source Han Sans CN;
      font-weight: 800;
      color: #F6F6F6;
    }
    .content {
      width: 100%;
      position: absolute;
      top: 194px;
      left: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      div{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 136px;
      }
      div:last-child{
        margin-right: 0;
      }
      .box{
        margin-right: 140px;
      }
      img{
        width: 62px;
        margin-bottom: 12px;
      }
    }
  }
  .helpyou{
    width: 100%;
    height: 800px;
    position: relative;
    /*background: url("~@/assets/img/solition/bg.png") no-repeat;*/
    /*background-position: bottom;*/
    .title{
      position: absolute;
      top: 68px;
      left: 0;
      text-align: center;
      width: 100%;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: #232330;
      z-index: 9;
    }
    .des{
      position: absolute;
      top: 0px;
      left: 0;
      text-align: center;
      width: 100%;
      font-size: 100px;
      font-family: Source Han Sans CN;
      font-weight: 800;
      color: #F6F6F6;
    }
    .content{
      width: 1300px;
      position: absolute;
      top: 194px;
      left: calc(50% - 650px);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .box{
        width: 300px;
        height: 255px;
        background: #FFFFFF;
        box-shadow: 0px 5px 10px 0px rgba(35, 35, 48, 0.05);
        border-radius: 15px;
        position: relative;
        overflow: hidden;
        .img{
          width: 100%;
          height: 178px;
          position: absolute;
          top: 0;
          left: 0;

        }
        .img img{
          width: 100%;
          height: 100%;
          transition: all .8s ease 0s;
          -webkit-transition: all .8s ease 0s;
        }
        .title1{
          height: 36px;
          line-height: 36px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #FFFFFF;
          background: rgba(0,0,0,0.5);
          position: absolute;
          top: 142px;
          left: 0;
          width: 100%;
          text-align: center;
        }
        .des1{
          height: 80px;
          position: absolute;
          bottom: 0px;
          padding: 6px 0;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          left: 0;
          width: 100%;
          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #282331;
          text-align: center;
          line-height: 18px;
        }
      }
      .box:hover{
        .img img{
          width: 120%;
          height: 120%;
          margin-left: -10%;
          margin-top: -10%;
        }
      }
    }
  }
  .BRILLIANT{
    width: 100%;
    height: 234px;
    position: relative;
    margin-top: -240px;
    .title{
      position: absolute;
      top: 64px;
      left: 0;
      text-align: center;
      width: 100%;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: #232330;
      z-index: 9;
    }
    .des{
      position: absolute;
      top: 0px;
      left: 0;
      text-align: center;
      width: 100%;
      font-size: 100px;
      font-family: Source Han Sans CN;
      font-weight: 800;
      color: #F6F6F6;
    }
  }
  .marginTop{
    margin-top: -60px;
    position: relative;
    z-index: 9;
  }
  .row{
    width: 100%;
    height: 464px;
    .title{
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #585EF8;
      display: flex;
      flex-display: row;
      justify-content: center;
      align-items: center;
      img{
        width: 40px;
        height: 26px;
        margin-right: 10px;
      }
    }
    .img{
      width: 1300px;
      display: block;
      margin: 80px auto 0;
    }
  }
}
</style>
